var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"modal-backdrops"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-headers"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}})]),_c('div',{staticClass:"modal-footers"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.closeModal}},[_vm._v("OK")])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }